import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Icon from 'react-icons-kit';
import {eye} from 'react-icons-kit/fa/eye';
import {eyeSlash} from 'react-icons-kit/fa/eyeSlash'
import JejakinLogo from './../../../images/jejakin-marketplace.svg';

class SetPassword extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loaderButton : false,
         newpassword : null,
         redirectToLogin : false,
         showpassword: false
      };
   }
   showPassword = () => {
      this.setState({showpassword: !this.state.showpassword});
   }
   setPassword = (e) => {
      e.preventDefault();
      this.setState({loaderButton:true})
      let data = {
         newpassword: this.state.newpassword
      }
      if(this.state.newpassword && this.state.newpassword.length > 5){
         axios({
            method: 'POST',
            url: process.env.REACT_APP_API_HOST + '/user/set-password/' + this.props.match.params.token,
            headers: {
               "Content-Type": "application/json"
            },
            data: data
         }).then(
            (response) => {
               console.log('response data forgot ', response.data);
               if (response.data.status === true){
                  toast.success("Sukses! Password baru telah tersimpan!");
                  setTimeout(() => {
                     this.setState({loaderButton:false})
                     toast.success("Login untuk melanjutkan!");
                  }, 1000);
                  setTimeout(() => {
                     this.setState({redirectToLogin:true})
                  }, 6000);
               } else {
                  if(response.data.error.length){
                     for(var er = 0; er < response.data.error.length; er++){
                        var obj = response.data.error[er];
                        for (var key in obj) { 
                           console.log(key, obj[key])
                           toast.error(key + ' : ' + obj[key] );
                        }
                        this.setState({ loaderButton: false })
                     }
                  } else {
                     this.setState({ loaderButton: false })
                     toast.error( response.data.error );
                  }
               }
            },
            (error) => {
               toast.error("Error! "+  error);
               setTimeout(() => {
                  this.setState({loaderButton:false})
               }, 1000);
            }
         );
      } else {
         this.setState({loaderButton:false})
         toast.error( 'Password harus 6 character atau lebih' );
      }
   }

   render() {
      if(this.state.redirectToLogin){
         return (<Redirect to={'/login'}/>)
      } 
      return (
         <React.Fragment>
            <div className="mpl-page">
               <ToastContainer />
               <div className="wrap-account">
                  <div className="wp-ac wrap-left">
                     <div className="logo-fixed">
                        <Link to="/"><img src={JejakinLogo} alt="Jejakin"/></Link>
                     </div>
                     <div className="wp-login">
                        <h2>
                           Password Baru
                        </h2>
                        <div className="row">
                           <div className="col-auto">
                              <h3 className="ts-underline mb-5">
                                 Password Baru
                              </h3>
                           </div>
                           <div className="col-auto">
                              <h3 className="ts-underline no-bg mb-5">
                                 <Link to="/login">
                                 Masuk
                                 </Link>
                              </h3>
                           </div>
                        </div>
                        <form id="formForgot" onSubmit={this.setPassword}>
                           <div className="form-group">
                              <label htmlFor="email" className="label-group">
                              Password Baru
                              </label>
                              {this.state.showpassword ? (
                                 <div className="field-group-input">
                                    <input id="password" type="text" className="custom-input" name="password" onChange={(e) => this.setState({newpassword: e.target.value})} />
                                    <div className="icon-group">
                                       <Icon size={24} icon={eye} style={{cursor:'pointer'}}  onClick={ () => {this.showPassword() } }/>
                                    </div>
                                 </div>
                              ) : (
                                 <div className="field-group-input">
                                    <input id="password" type="password" className="custom-input" name="password" onChange={(e) => this.setState({newpassword: e.target.value})} />
                                    <div className="icon-group">
                                       <Icon size={24} icon={eyeSlash} style={{cursor:'pointer'}}  onClick={ () => {this.showPassword() } }/>
                                    </div>
                                 </div>
                              ) }
                           </div>
                           
                           <div className="form-group mb-0">
                              <button className="btn btn-green ">
                              {this.state.loaderButton === true ? (
                                 <div className="loader"></div>
                              ) : ('SIMPAN PASSWORD BARU')} 
                              </button>
                              
                           </div>
                        </form>
                     </div>
                  </div>
                  <div className="wp-ac wrap-right">
                     <div className="green-ov">&nbsp;</div>
                     <div className="content-highlight">
                        <h2>
                        Accelerating Climate Action with Technology
                        </h2>
                     </div>
                  </div>
               </div>
            </div>
         </React.Fragment>
      );
   }
}
   
export default SetPassword;